import e from "./_ListCache.js";
import s from "./_Map.js";
import r from "./_MapCache.js";
var h = e, o = s, c = r, f = 200;
function n(_, i) {
  var t = this.__data__;
  if (t instanceof h) {
    var a = t.__data__;
    if (!o || a.length < f - 1)
      return a.push([_, i]), this.size = ++t.size, this;
    t = this.__data__ = new c(a);
  }
  return t.set(_, i), this.size = t.size, this;
}
var u = n;
export {
  u as default
};
//# sourceMappingURL=_stackSet.js.map
